import { cartFieldsQuery } from './getCart'
import { gql } from './gql'

/**
 * Get's the string for `removeProduct` mutation.
 * This mutation removes a product from an existing cart.
 */
export const CART_REMOVE_PRODUCT = gql`
  mutation CartRemoveProductMutation(
    $cartRemoveProductStorefrontName: String!
    $cartRemoveProductSessionUid: ID!
    $cartRemoveProductData: CartProductOpInput!
  ) {
    cartRemoveProduct(
      storefrontName: $cartRemoveProductStorefrontName
      sessionUid: $cartRemoveProductSessionUid
      data: $cartRemoveProductData
    ) {
      ${cartFieldsQuery}
    }
  }
`
